<template>
  <div class="page-content">
    <div class="content-wrapper">
      <div class="content d-flex justify-content-center align-items-center">
        <div class="login-form">
          <div v-if="isMarket" class="card  rounded mb-3 mt-2">
            <div v-if="withRegistration" class="card-body">
              <a href="https://demo.codico.io/my/">https://demo.codico.io/my/</a><br><br>
              Customer login:
              <strong
                v-clipboard="() => 'demo@codico.loc'"
                :title="$t('general.copy')"
                class="cursor-pointer"
                @click="showCopyAlert"><span class="pr-1">demo@codico.loc</span>&nbsp;
                  <i class="icon-copy font-size-lg cursor-pointer"></i>
              </strong><br>
              Password:
              <strong
                v-clipboard="() => 'demo'"
                :title="$t('general.copy')"
                class="cursor-pointer"
                @click="showCopyAlert"><span class="pr-1">demo</span>&nbsp;
                  <i class="icon-copy font-size-lg cursor-pointer"></i>
              </strong>
            </div>

            <div v-else class="card-body">
              <a href="https://demo.codico.io/console/">https://demo.codico.io/console/</a><br><br>
              Admin Login:
              <strong
                v-clipboard="() => 'demo-admin@codico.loc'"
                :title="$t('general.copy')"
                class="cursor-pointer"
                @click="showCopyAlert"><span class="pr-1">demo-admin@codico.loc</span>&nbsp;
                  <i class="icon-copy font-size-lg cursor-pointer"></i>
              </strong><br>
              Password:
              <strong
                v-clipboard="() => 'demo'"
                :title="$t('general.copy')"
                class="cursor-pointer"
                @click="showCopyAlert"><span class="pr-1">demo</span>&nbsp;
                  <i class="icon-copy font-size-lg cursor-pointer"></i>
              </strong>

              <br><br>

              Company login:
              <strong
                v-clipboard="() => 'demo@codico.loc'"
                :title="$t('general.copy')"
                class="cursor-pointer"
                @click="showCopyAlert"><span class="pr-1">demo@codico.loc</span>&nbsp;
                <i class="icon-copy font-size-lg cursor-pointer"></i>
              </strong><br>
              Password:
              <strong
                v-clipboard="() => 'demo'"
                :title="$t('general.copy')"
                class="cursor-pointer"
                @click="showCopyAlert"><span class="pr-1">demo</span>&nbsp;
                  <i class="icon-copy font-size-lg cursor-pointer"></i>
              </strong>




            </div>
          </div>

          <div class="card mb-0">
            <div class="card-body">
              <div class="text-center mb-3">
                <i
                  class="icon-reading icon-2x text-slate-300 border-slate-300 border-3 rounded-round p-3 mb-3 mt-1"
                />
                <h5 class="mb-0">{{ strings.auth.login_header }}</h5>
                <span class="d-block text-muted">
                  {{ strings.auth.login_desc }}
                </span>
              </div>

              <slot>
                <sign-in />
              </slot>

              <div v-if="withRegistration" class="text-center">
                {{ strings.auth.login_register_text }}
                <router-link :to="registerRoute">
                  {{ strings.auth.sign_up }}
                </router-link>
              </div>
              <template v-if="withForgot">
                <hr />
                <div class="text-center">
                  <router-link :to="forgotRoute">
                    {{ strings.auth.login_forgot_text }}
                  </router-link>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SignIn from '../components/auth/auth-sign-in'
import AuthRoutesMixin from './AuthRoutesMixin'
import AuthConfig from '../modules/auth/config'
import strings from '../strings'
import ClipBoard from 'v-clipboard'
import Vue from 'vue'

Vue.use(ClipBoard)

export default {
  name: 'LoginView',
  components: { SignIn },
  mixins: [AuthRoutesMixin],
  data () {
    return {
      isMarket: false
    }
  },
  computed: {
    withRegistration() {
      return AuthConfig.withRegistration
    },
    withForgot() {
      return AuthConfig.withForgot
    },
    strings() {
      return strings
    },
  },
  created() {
    if(process.env.VUE_APP_ENV === 'market') this.isMarket = true;
  },
  methods: {
    showCopyAlert() {
      this.$toast.success(this.$t('general.copied'))
    },
  }
}
</script>
